import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { isAdmin } from '../utils/role.util';

/**
 * Synchronous, same shape as `authGuard` — reads the roles already persisted in
 * the session (PASO 0: `user.roles` ships in the login payload), no extra
 * request. Non-admins are bounced to /dashboard, not /login: they have a valid
 * session, they just can't be here. Pair it with `authGuard` in the route so an
 * unauthenticated hit still lands on /login.
 */
export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return isAdmin(auth.auth()?.user?.roles) || router.createUrlTree(['/dashboard']);
};
